export default __webpack_public_path__ + "static/media/pgtech-logo-black.3da5b962.png";